import { setGetPlayersByIdAction } from '../action';
import { getPlayersById } from '../api/getPlayersById';

export const setGetPlayersById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getPlayersById(params);
            dispatch(setGetPlayersByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}